import { useEffect, useState } from "react";
import {useAnimation, motion} from "framer-motion"
import { useInView } from "react-intersection-observer";
import { container2, child} from "../../../../variants"

import {ReactComponent as SlideIcon} from '../../../../assets/logos/attend-slide-icon.svg'
import {ReactComponent as LeftArrow} from '../../../../assets/logos/hr-left-arrow.svg'

const hrData = [
    {id:"data1", icon:<SlideIcon />, title:"Shift Management", content:"Easily manage shifts and customize policies for all employee groups, whether fixed or flexible."},
    {id:"data2", icon:<SlideIcon />, title:"Attendance Tracking and Integration", content:"Track attendance securely with biometric, web, and geo clock-in options, offering versatile capture methods."},
    {id:"data3", icon:<SlideIcon />, title:"Overtime & Compensation", content:"Manage attendance and compensation seamlessly with options for partial-day adjustments, overtime pay, and compensatory time off, ensuring fairness and efficiency."},
    {id:"data4", icon:<SlideIcon />, title:"Remote Work and On-Duty Policies", content:"Create clear remote work and on-duty policies for smooth transitions between WFH and in-office tasks, ensuring clarity and structure in hybrid work environments."},
]

const AttendanceSlide = () => {

    const [scrollRight, setScrollRight] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    const [data] = useState(hrData);

    const ctrls = useAnimation();

    const { ref, inView } = useInView({
        threshold: 0.2,
        triggerOnce: false,
      });

    useEffect(() => {
        const updateDimensions = () => {
            const scrollingContainer:any = document.getElementById("hrSlideContainer");
            const child:any = document.getElementById("hrChild");
            const scrollAmount = Math.floor(scrollingContainer.offsetWidth / (child.offsetWidth))
            const right = hrData.length - scrollAmount
            setScrollRight(right)
        }

        updateDimensions();

        window.addEventListener("resize", updateDimensions);

        if (inView) {
            ctrls.start("visible");
        }
        if (!inView) {
            ctrls.start("hidden");
        }

        return () => {
            window.removeEventListener("resize", updateDimensions);
        };
        
    }, [data, ctrls, inView])

    const slideRight = () => {

        const scrollingContainer:any = document.getElementById("hrSlideContainer");
        const child:any = document.getElementById("hrChild");
       
        setScrollRight(prevScrollRight => prevScrollRight - 1);
        setScrollLeft(prevScrollLeft => prevScrollLeft + 1);
    
        
        scrollingContainer.scrollLeft += (child.offsetWidth + 40)

    }

    const slideLeft = () => {

        const scrollingContainer:any = document.getElementById("hrSlideContainer");
        const child:any = document.getElementById("hrChild");

        setScrollLeft(prevScrollLeft => prevScrollLeft - 1);
        setScrollRight(prevScrollRight => prevScrollRight + 1);

       
        scrollingContainer.scrollLeft -= (child.offsetWidth + 40)
       
    }

    const shouldShowLeftArrow = scrollLeft > 0;
    const shouldShowRightArrow = scrollRight > 0;

    
  return (
    <motion.div ref={ref} variants={container2} initial="hidden" animate={ctrls} id="hrSlide" className='hr-slide-par p-t-50 mb-40 d-flex flex-column'>
        <motion.div variants={child} className='hr-slide-child  d-flex flex-column  align-self-center'>
            <h3 className='h1-size font-weight-600 text-center'>Empower Your Team with <span className="col-secondary"> Flexible, Automated </span>Attendance Solutions.</h3>
            <div className='hr-slide-one d-flex flex-column align-self-center'>
                <p className='font-1 p-size font-weight-400 text-center'> Optimize your workforce management with flexible, automated attendance solutions designed to meet your team’s unique needs and enhance productivity daily.</p>
            </div>
            <div className='hr-slide-two mt-20 d-flex flex-column align-items-center '>
                <ul id="hrSlideContainer" className='hr-slide-ul d-flex flex-row justify-content-between align-self-center'>
                        {hrData.map((each)=>
                            <li key={each.id} id="hrChild" className='hr-slide-items m-r-40'>
                                {each.icon}
                                <h3 className='hr-slide-head mt-10 text-18 font-weight-600'>{each.title}</h3>
                                <p className='hr-slide-para p-size font-weight-400'>{each.content}</p>
                            </li>
                        )}
                </ul>
            </div>
            <div className="hr-slide-icons d-flex flex-row justify-content-between align-self-center">
                <div className="slide-icon-flat d-flex flex-row align-items-center p-l-15">
                    <div style={{backgroundColor:scrollLeft === 0?"#12A8A8":"#D9D9D9"}} className="w-px-30 h-px-3 rounded-5 m-r-10"></div>
                    <div style={{backgroundColor:scrollRight === 0?"#12A8A8":"#D9D9D9"}} className="w-px-30 h-px-3 rounded-5 slide-line"></div>
                </div>
                <div className="d-flex flex-row icon-con">
                   {shouldShowLeftArrow && <LeftArrow onClick={slideLeft} className='icon-left-arrows'/>}
                    {shouldShowRightArrow && <LeftArrow onClick={slideRight} className='icon-right-arrows' />}
                </div>
            </div>
        </motion.div>
    </motion.div>
  )
}

export default AttendanceSlide